import Dimensions from './dimensions';

export default (dataURL: string): Promise<Dimensions> => {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => {
      const imageWidth = image.width;
      const imageHeight = image.height;
      resolve({
        width: imageWidth > 300 ? 300 : imageWidth,
        height: Math.round(imageHeight * (300 / imageWidth))
      });
    };
    image.src = dataURL;
  });
};
